<template>
  <div tabindex="0">
    <div class="rebetContainer">
      <button
        type="button"
        class="rebet-confirmation-btn submitMsgFail "
        value="N"
        :class="classBtnCancel"
        @click="cancel"
      >
          {{ $t('cancel') }}
      </button>
      <button
        type="button"
        class="rebet-confirmation-btn submitMsgSucc"
        value="Y"
        :class="classBtnConfirm"
        @click="confirm"
      >
          {{ $t('confirm') }}
      </button>
      <button type="button"
        class="rebet-btn rebet-btn-active-false"
        title="Cược lại"
        :disabled="isRebet === false"
        @click="showDialog"
      >
          {{ $t('rebet') }}
      </button>
      <div class="rebet-btn-arrow-left"></div>
    </div>
</div>
</template>

<script>
import TickIcon from '@assets/icons/tick.svg';
import CrossIcon from '@assets/icons/cross.svg';
import PresetIcon from '@assets/icons/preset.svg';
import AtSign from '@assets/icons/at-sign.svg';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    TickIcon, CrossIcon, PresetIcon, AtSign,
  },
  props: {
    isRebet: Boolean,
  },
  data() {
    return {
      isShowButton: false,
    }
  },
  computed: {
    classBtnCancel: function () {
      return {
        'rebet-confirmation-btn-cancel-true': this.isShowButton && this.isRebet
      }
    },
    classBtnConfirm: function () {
      return {
        'rebet-confirmation-btn-confirm-true': this.isShowButton && this.isRebet
      }
    }
  },
  watch: {
    isRebet: function (newVal) {
      this.isShowButton = false;
    },
  },
  methods: {
    showDialog(e) {
      this.isShowButton = true;
    },
    cancel(e) {
      // console.log('cancel');
      this.isShowButton = false;

    },
    confirm(e) {
      // console.log('confirm');
      this.isShowButton = false;
      this.$emit('handle-reBetting');
    },
  }
}
</script>

<style>

</style>
